import React, { Component, isValidElement } from "react";
import TableList from "./CustomTool/TableList";
import { Edit, Delete, LogoDevOutlined } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { withRouter } from "../HOC/withRouter";
import { apiURL, fetchReciept } from "./API";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import {
  applyTrimOnObjectValues,
  getRowColData,
  get_YMD_from_SYS,
  validatedate_min_max,
} from "../SystemUtility/SystemUtility";

class PaymentModeTable extends Component {
  state = {
    LedgerGroup: [],
    LedgerGroupList: [],
    defaultSetting: {},
    DefaultEntrySettingList: [],
    PaymentData: [],
    dec_amount: "",
    columns: [
      // { id: "Action", label: "Search", name: "Search" },
      {
        id: "chk_paymentmode",
        label: "",
        type: "Chk",
        // defValue: 0,
        CtrlProps: { behaviour: "radio" },
      },
      { id: "vac_ledgername", label: "Payment Mode Ledger" },
      {
        id: "dec_amount",
        label: "Payment Mode Amount",
        type: "CtTxtAmt",
        // defValue: 0,
        CtrlProps: { defValue: "", width: 100, maxLength: 10 },
      },
      {
        id: "vac_chequeno",
        label: "Cheque No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 6 },
      },
      {
        id: "vac_referenceno",
        label: "Reference No",
        type: "CtTxt",
        CtrlProps: { value: "", width: 100, maxLength: 100 },
      },
      {
        id: "dat_transactiondate",
        label: "Transaction Date",
        type: "CtDtp",
        CtrlProps: { value: "", maxLength: 20 },
      },
      {
        id: "vac_remark",
        label: "Remark",
        type: "CtMultiLineText",
        CtrlProps: { value: "", width: 100, maxLength: 1000 },
      },
    ],
    // actionList: [
    //   {
    //     name: "Edit",
    //     icon: <Edit />,
    //     link: "RecieptEntry:",
    //     actionType: "AlertResponsive",
    //   },
    //   {
    //     name: "Delete",
    //     icon: <Delete />,
    //     link: "RecieptEntry:",
    //     actionType: "AlertResponsive",
    //     hide:
    //       this.props.userPrivilege.Receipt == "R" ||
    //       this.props.userPrivilege.Receipt == "W",
    //   },
    // ],
    // keyColumn: [
    //   "bint_acid",
    //   "vac_groupname",
    //   "vac_ledgername",
    //   "dec_amount",
    //   "vac_chequeno",
    //   "vac_referenceno",
    //   "dat_transactiondate",
    //   "vac_remark",
    // ],
    formData: {},
    dataLoadStatus: true,
    ARD: null,
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    // document.title = "RiTe Account : Payment Mode Table";
    // this.props.setActiveMenu("PaymentModeTable");
    // this.getInfo(this.props.DefaultEntrySettingList, this.props.LedgerNameList, this.props.PaymentLedgerNameList, this.props.PaymentData)
    // this.setSearchColumns();
    // this.props.verifyUserID(() => {
    //     this.getInfo(true);
    // });
    this.setOnComponentEvent(
      this.props.DefaultEntrySettingList,
      this.props.PaymentLedgerNameList,
      this.props.PaymentData,
      this.props.txtAmount
    );
    this.getInfo(
      this.props.DefaultEntrySettingList,
      this.props.PaymentLedgerNameList,
      this.props.PaymentData
    );
  }

  componentWillReceiveProps(newProps) {
    //console to display Payment Ledgername List & rows & it's !== reult
    if (
      (newProps.DefaultEntrySettingList &&
        newProps.DefaultEntrySettingList !=
          this.state.DefaultEntrySettingList) ||
      (newProps.PaymentLedgerNameList &&
        newProps.PaymentLedgerNameList !== this.state.rows) ||
      (newProps.PaymentData &&
        newProps.PaymentData !== this.state.PaymentData) ||
      (newProps.txtAmount && newProps.txtAmount != this.state.dec_amount) /* ||
            (newProps.cmbTranType == undefined || newProps.cmbTranType === "Paid") */ // (newProps.LedgerNameList) ||
    ) {
      // console.log("newProps", newProps);
      this.setOnComponentEvent(
        newProps.DefaultEntrySettingList,
        newProps.PaymentLedgerNameList,
        newProps.PaymentData,
        newProps.txtAmount
      );

      // this.setState({ DefaultEntrySettingList, LedgerNameList, PaymentLedgerNameList });
    }
    // if (newProps.txtAmount && newProps.txtAmount > 0) {
    //     this.onAmountTextChange(newProps.txtAmount)
    // }
  }
  //#endregion Component

  //#region handle
  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {
      // console.log("colID", colID);
      if (colID === "chk_paymentmode" || colID === "dec_amount") {
        this.setPaymentModeTableDataForSave(colID === "chk_paymentmode");
      } else {
        this.props.setPaymentData(this.state.rows);
      }
    });
  };
  //#endregion handle

  //#region function

  setOnComponentEvent = (
    DefaultEntrySettingList,
    PaymentLedgerNameList,
    PaymentData,
    txtAmount
  ) => {
    let dec_amount = txtAmount;
    this.setState(
      {
        DefaultEntrySettingList,
        // rows: newProps.PaymentLedgerNameList,
        PaymentData,
        dec_amount,
      },
      () => {
        this.getInfo(
          DefaultEntrySettingList,
          PaymentLedgerNameList,
          PaymentData
        );
      }
    );
  };

  navigateTo = (link) => {
    this.props.navigate("/" + link);
  };

  validatePaymentModeAmount = () => {
    let result = false,
      dec_amount = 0;
    if (this.state.rows.length > 0) {
      this.state.rows.map((row, index) => {
        if (row.dec_amount !== null && row.dec_amount !== undefined) {
          dec_amount += Number(row.dec_amount);
        }
      });
      if (dec_amount === Number(this.state.formData.txtAmount)) {
        result = true;
      } else if (dec_amount === 0) {
        this.props.toastErrorMsg("Enter Payment Mode Amount", "txtAmount");
      } else {
        this.props.toastErrorMsg(
          "Receipt Amount must be same as Total of Payment Mode Amount",
          "txtAmount"
        );
      }
    } else {
      result = true;
    }
    return result;
  };

  getInfo = (DefaultEntrySettingList, PaymentLedgerNameList, PaymentData) => {
    /** This Function Apply Default Payment Mode Check and call other function after setstate */
    // console.log("LedgerNameList", LedgerNameList);
    // console.log("PaymentLedgerNameList", PaymentLedgerNameList);
    // console.log("DefaultEntrySettingList", DefaultEntrySettingList);
    // console.log("PaymentData", PaymentData);
    let dataLoadStatus = false;
    let defaultSetting = DefaultEntrySettingList;
    let rows = [],
      // PaymentLedgerNameList = [],
      rowsCount = rows.length;
    if (PaymentLedgerNameList && PaymentLedgerNameList.length > 0) {
      rows = PaymentLedgerNameList;
      rowsCount = rows.length;
      // PaymentLedgerNameList = PaymentLedgerNameList;
    }
    // console.log("defaultSetting", defaultSetting);
    let checkedRowIndex = -1,
      row_chk_paymentmode_true_index = -1,
      amtSetInAnyRowCount = 0;
    // console.log('DD : retrows @ 1 : ', retrows)
    let retrows = rows.map((row, index) => {
      if (row.chk_paymentmode === true) {
        checkedRowIndex = index;
      }
      if (
        row.vac_ledgername === defaultSetting.vac_ledgername ||
        (row.vac_backgroundprocess &&
          row.vac_backgroundprocess === "Delivery Responsible Person")
      ) {
        // console.log("rows", rows);
        row_chk_paymentmode_true_index = index;
      }
      if (Number(row.dec_amount) > 0) {
        amtSetInAnyRowCount++;
      }
      return row;
    });
    if (
      checkedRowIndex == -1 &&
      amtSetInAnyRowCount <= 1 &&
      rows &&
      row_chk_paymentmode_true_index >= 0 &&
      rows[row_chk_paymentmode_true_index]
    ) {
      rows[row_chk_paymentmode_true_index].chk_paymentmode = true;
      // retrows = rows.map((row, index) => {
      //     if (row.vac_ledgername === defaultSetting.vac_ledgername) {
      //         row.chk_paymentmode = true;
      //     }
      //     return row;
      // });
    } else if (amtSetInAnyRowCount > 1) {
      retrows = rows.map((row, index) => {
        row.chk_paymentmode = false;
        return row;
      });
    }
    this.setState({ dataLoadStatus, rows: retrows }, () => {
      this.onEditEntry(PaymentData, retrows, amtSetInAnyRowCount);
      this.onAmountTextChange(this.state.dec_amount);
    });
    // document.getElementById("dtpDate").focus();
  };

  onEditEntry = (PaymentData, rows, amtSetInAnyRowCount) => {
    /**Set rows based on two different arrays that contains different part of rows information only EditSrNo found > 0*/
    if (
      this.props.Edit_SrNo &&
      Number(this.props.Edit_SrNo) > 0 &&
      Number(amtSetInAnyRowCount) === Number(0)
    ) {
      let rowsCount = 0;
      if (PaymentData && PaymentData.length > 0) {
        PaymentData.map((odd) => {
          let isFound = 0;
          rows.map((rod) => {
            if (rod.vac_ledgername === odd.vac_ledgername) {
              // rod.vac_value = odd.vac_value;
              rod.dec_amount = odd.dec_amount;
              rod.vac_chequeno = odd.vac_chequeno;
              rod.vac_referenceno = odd.vac_referenceno;
              rod.dat_transactiondate = odd.dat_transactiondate;
              rod.vac_remark = odd.vac_remark;
              // rod.vac_groupname = odd.vac_groupname;
              isFound++;
            }
          });
          if (isFound === 0) {
            rows.push({
              vac_ledgername: odd.vac_ledgername,
              dec_amount: odd.dec_amount,
              vac_chequeno: odd.vac_chequeno,
              vac_referenceno: odd.vac_referenceno,
              dat_transactiondate: odd.dat_transactiondate,
              vac_remark: odd.vac_remark,
              // vac_groupname: odd.vac_groupname,
              // bint_displayorderno: rowsPaymentMode.length + 1,
            });
          }
        });
        rowsCount = rows.length;
      }
      let amtCount = 0,
        amtIndex = 0;
      rows = rows.map((row, index) => {
        if (Number(row.dec_amount) > 0) {
          amtIndex = index;
          amtCount++;
        }
        return row;
      });
      if (amtCount > 0) {
        rows = rows.map((row, index) => {
          row.chk_paymentmode = false;
          return row;
        });
        if (amtCount === 1) rows[amtIndex].chk_paymentmode = true;
      }
      this.setState(
        {
          rows,
          rowsCount,
        },
        () => {
          // document.getElementById("cmbLedgerGroup").focus();
        }
      );
    }
  };

  setPaymentModeTableDataForSave = (isCalledByChkClicked) => {
    if (this.state.rows.length > 0) {
      let amtSetInAnyRowCount = 0,
        amtSetRowIndex = [],
        rows = this.state.rows.map((row, index) => {
          // console.log("row @ index : ", index, row);
          // console.log("Number(row.dec_amount)", Number(row.dec_amount));
          // console.log('Number(row.dec_amount) > 0 || Number(row.dec_amount) < 0',Number(row.dec_amount) > 0 || Number(row.dec_amount) < 0)
          if (Number(row.dec_amount) > 0 || Number(row.dec_amount) < 0) {
            amtSetInAnyRowCount++;
            amtSetRowIndex.push(index);
          }
          // console.log("row", row);
          return row;
        });
      // console.log("amtSetInAnyRowCount",amtSetInAnyRowCount);
      if (amtSetInAnyRowCount <= 1 || isCalledByChkClicked) {
        rows = this.state.rows.map((row) => {
          // console.log("row", row);
          if (row.chk_paymentmode === true) {
            return { ...row, dec_amount: Number(this.props.txtAmount) };
          } else if (isCalledByChkClicked == true) {
            return { ...row, dec_amount: "" };
          } else {
            return row;
          }
        });
      } else {
        amtSetRowIndex.forEach((idx) => {
          rows[idx].chk_paymentmode = false;
        });
      }
      this.setState(
        {
          rows,
        },
        () => {
          // console.log("this.state.rows", this.state.rows);
          this.props.setPaymentData(this.state.rows);
        }
      );
    }
  };

  onAmountTextChange = (txtAmount) => {
    let rows = this.state.rows.map((row, index) => {
      if (row.chk_paymentmode == true) {
        row.dec_amount = txtAmount;
        // console.log("row.dec_amount hvshcvshcvhsv", row.dec_amount);
      }
      return row;
    });
    this.setState({ rows });
  };
  //#endregion

  render() {
    // console.log("this.props.txtAmount", this.props.txtAmount);
    let rows = this.state.rows;
    let rowsCount = this.state.rowsCount;
    // console.log("this.props", this.props);
    return (
      <form>
        {/* <Progress
                    color="primary"
                    display={this.state.dataLoadStatus !== true}
                /> */}
        <br />
        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          onKeyDown={this.props.onKeyDown}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          //   handleOnActionClick={this.handleARDonActionClick}
          // actionList={this.state.actionList}
          //   keyColumn={this.state.keyColumn}
          //   handleOnSearchChange={this.handleOnSearchChange}
          //   searchColumns={this.state.searchColumns}
          //   searchData={this.state.searchData}
          // provideSearch={true}
          //   handleOnNewEntryClick={this.handleOnNewEntryClick}
          handleOnRowDataChange={this.handleOnRowDataChange}
          // toolTipNewEntry='New Product Entry'
        />
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(PaymentModeTable))));
